//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../no/Builder.js";
let d=[[[0,"IncludeSubfolders",1,0],[0,"InputFolder",1,0],[0,"IsPartSymbol",1,0],[0,"IsTeamcenter",1,0],[0,"LibraryPath",1,0],[0,"PreserveFolderStructure",1,0],[0,"SelectMode",1,0]],[[[],"StartImport",{},0,0],[["numFiles","files"],"GetFilesToProcess",{},0,0],[["files"],"SetFilesToProcess",{},1,0],[["numFiles","files"],"GetExpandedFiles",{},0,0],[["files"],"SetExpandedFiles",{},1,0]],[]];
SPLM.Annotations.ImportSymbolBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.ImportSymbolBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Annotations.ImportSymbolBuilder.FileFolder = Object.freeze({
    "File" : "File", "Folder" : "Folder"});

export default SPLM;